export enum TargetingDataPointTitle {
  SuitabilityScore = 'suitabilityScore',
  PurchasingPower = 'purchasingPower',
  InstitutionRating = 'institutionRating',
  OpportunityRank = 'opportunityRank'
}

export type TargetingDataPointFields = {
  title: string;
  info: string;
  primaryInfo?: string;
  secondaryInfo?: string;
};

type TargetingDataPointLocalization = {
  [key in TargetingDataPointTitle]: TargetingDataPointFields;
};

export const TargetingDataPointLocalizationKeys: TargetingDataPointLocalization = {
  [TargetingDataPointTitle.SuitabilityScore]: {
    title: 'suitabilityScore',
    info: 'suitabilityScoreInfo'
  },
  [TargetingDataPointTitle.PurchasingPower]: {
    title: 'purchasingPower',
    info: 'purchasingPowerInfo',
    primaryInfo: 'institutionSurvPurchasingPowerInfo',
    secondaryInfo: 'fundSurvPurchasingPowerInfo'
  },
  [TargetingDataPointTitle.InstitutionRating]: {
    title: 'institutionRating',
    info: 'institutionRatingInfo',
    primaryInfo: 'survInstitutionRatingInfo'
  },
  [TargetingDataPointTitle.OpportunityRank]: {
    title: 'opportunityRank',
    info: 'opportunityRankInfo',
    primaryInfo: 'institutionSurvOportunityRankInfo'
  }
};

export const TargetingDataPointLocalization: TargetingDataPointLocalization = {
  [TargetingDataPointTitle.SuitabilityScore]: {
    title: 'Suitability Score',
    info: 'Suitability is a percentile ranking of the portfolio universe based on the alignment between your company’s fundamentals and the observed investment strategies of investment managers.'
  },
  [TargetingDataPointTitle.PurchasingPower]: {
    title: 'Purchasing Power',
    info: 'Purchasing power is the number of shares a portfolio would need to buy or sell for its position in your company to be normal, or average, for companies with a similar float value.',
    primaryInfo: 'Institution Purchasing Power is always based on surveillance data.',
    secondaryInfo: 'Fund Purchasing Power is always based on public data.'
  },
  [TargetingDataPointTitle.InstitutionRating]: {
    title: 'Institution Rating',
    info: 'Institution Rating indicates the importance of meeting with a specific institution, including owners as well as non-owners.',
    primaryInfo: 'Institution Rating is always based on surveillance data.'
  },
  [TargetingDataPointTitle.OpportunityRank]: {
    title: 'Opportunity Rank',
    info: 'Opportunity Rank is a descending order of institutions based on the relative likelihood and opportunity size of buying for each. Opportunity Rank incorporates the suitability, purchasing power, and portfolio exposures of each institution and its underlying funds.',
    primaryInfo: 'Institution Opportunity Rank is always based on surveillance data.'
  }
};
